export default "__VITE_ASSET__NgsTfSQW__"